<template>
  <v-container fluid fill-height  >
    <v-row>
      <v-col cols="12" md="2" lg="2">

      </v-col>
      <v-col cols="12" md="8" lg="8" align="center">
        <div v-if="page_loading">
          <loading :page_loading="page_loading" />
        </div>
        <div v-else-if="detail_order == null">
          <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0" align="center">
              <h1 class="ml-2 mb-4">{{ use_language.purchase_order_not_found }}</h1>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <loading :loading="loading" />
          <v-card elevation="1" class="v-card-bottom-30">
            <v-card-title elevation="1" style="background-color: #fff;">
              <v-icon size="20" color="info ">fa-file</v-icon>
              <span class="pl-3">{{ use_language.purchase_order_2 }} {{ format_order_id(detail_order.id) }}</span>
              <v-spacer />
            </v-card-title>
          </v-card>

          <v-card class="v-card-bottom-30" elevation="1">
            <v-card-title>
              <v-icon size="20" color="orange darken-4">fa-file-alt</v-icon>
              <span class="pl-3">{{ use_language.product }}</span>
            </v-card-title>
            <v-divider />
            <v-card-text class="pl-10">
              <v-simple-table v-if="product_list.length != 0" class="packhai-border-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center" width="100px">{{ use_language.image }}</th>
                      <th class="text-left">{{ use_language.product }}</th>
                      <th class="text-right">{{ use_language.quantity }}</th>
                      <th class="text-right">{{ use_language.price_per_piece }}</th>
                      <th class="text-right">{{ use_language.discount }}</th>
                      <th class="text-right">{{ use_language.total_price }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in product_list" :key="item.name">
                      <td class="text-center">
                        <div align="center">
                          <v-img style="margin:5px;" v-if="item.photoLink != null" :src="item.photoLink" aspect-ratio="1"
                            class="grey lighten-2" width="40" height="40" @click="photo_click(item.photoLink)"></v-img>
                        </div>

                      </td>
                      <td class="text-left">
                        {{ item.productName }}
                        <span class="fn-10 color-b3">
                          {{ (item.prop1Description != null ? item.prop1Description : "") + (item.prop2Description !=
                            null ? " , " + item.prop2Description : "") }}
                        </span>
                      </td>
                      <td class="text-right">{{ item.quantity }}</td>
                      <td class="text-right">{{ item.unitPrice }}</td>
                      <td class="text-right">{{ item.discount }}</td>
                      <td class="text-right"><span v-if="item.quantity != null">{{ format_price(item.unitPrice *
                          item.quantity) }}</span></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider />
              <v-card tile elevation="0" class="my-3 px-3">
                <v-row class="pt-3 pb-3" align="end" style="background: #fff">
                  <v-col cols="12" md="6" class="py-0"></v-col>
                  <v-col cols="12" md="6" class="py-0 " align="end">
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="6" class="py-0" align="end"><strong> <span
                            v-if="detai_VATType == null || detai_VATType == 0 || detai_VATType == 1">{{ use_language.total_price }}</span>
                          <span v-if="detai_VATType == 2">{{ use_language.price_including_tax }}</span> <span
                            v-if="detai_VATType == 3">{{ use_language.price_not_include_tax }}</span>
                        </strong></v-col>
                      <v-col cols="6" class="py-0 " align="end">
                        <span v-if="this.detai_totalPrice != null">
                          {{ format_price(this.detai_totalPrice) }} {{ use_language.baht }}</span>
                        <span v-else> 0 {{ use_language.baht }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="6" class="py-0" align="end"><strong>{{ use_language.delivery_fee }}</strong></v-col>
                      <v-col cols="6" class="py-0 " align="end">
                        <span v-if="this.detai_DeliveryCost != null">{{ format_price(this.detai_DeliveryCost) }}
                          {{ use_language.baht }}</span>
                        <span v-else> 0 {{ use_language.baht }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="6" class="py-0" align="end"><strong>{{ use_language.discount }}</strong></v-col>
                      <v-col cols="6" class="py-0 " align="end">
                        <span v-if="this.detai_DeliveryCost != null">{{ format_price(this.detai_OrderDiscount * -1) }}
                          {{ use_language.baht }}</span>
                        <span v-else> 0 {{ use_language.baht }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;">
                      <v-col cols="6" class="py-0" align="end">
                        <strong v-if="this.detai_VATType == 1">{{ use_language.no_vat_ }}</strong>
                        <strong v-else-if="this.detai_VATType == 2">{{ use_language.vat_included_ }}</strong>
                        <strong v-else-if="this.detai_VATType == 3">{{ use_language.vat_excluded_ }}</strong>
                      </v-col>
                      <v-col cols="6" class="py-0 " align="end">
                        <span v-if="this.detai_DeliveryCost != null">{{ format_price(this.detai_VATAmount) }} {{ use_language.baht }}</span>
                        <span v-else> 0 {{ use_language.baht }}</span>
                      </v-col>
                    </v-row>
                    <v-row align="end" style="height: 30px;" class="pb-3">
                      <v-col cols="6" class="py-1" align="end"><strong>{{ use_language.total_all }}</strong></v-col>
                      <v-col cols="6" class="py-1 " align="end" style="color: green">
                        <b>
                          <span v-if="this.detail_sum_unintPrice_and_DeliveryCost != null && this.detai_VATType == 3">{{
                            format_price(parseFloat(this.detai_totalPrice) + parseFloat(this.detai_DeliveryCost) +
                              parseFloat(this.detai_VATAmount) - parseFloat(this.detai_OrderDiscount) )}} {{ use_language.baht }}</span>
                          <span
                            v-else-if="this.detail_sum_unintPrice_and_DeliveryCost != null && this.detai_VATType == 2">{{
                              format_price(parseFloat(this.detai_totalPrice) + parseFloat(this.detai_DeliveryCost) -
                            parseFloat(this.detai_OrderDiscount) )}} {{ use_language.baht }}</span>
                          <span
                            v-else-if="this.detail_sum_unintPrice_and_DeliveryCost != null && this.detai_VATType == 1">{{
                              format_price(parseFloat(detai_totalPrice) + parseFloat(detai_DeliveryCost) +
                                (detai_DeliveryCost ==null ? 0
                            : parseFloat(detai_OrderDiscount)*-1)) }} {{ use_language.baht }} </span>
                          <span v-else> 0 {{ use_language.baht }} </span>
                        </b>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </v-card>
          <!-- ชำระเงิน -->
          <v-card class=" v-card-bottom-30 text-left" elevation="1"
            v-if="detailOrderProductPlatform.length == 0 && this.detail_IsCOD == false">
            <v-card-title>
              <v-icon size="20" color="success darken-4">fa-file-invoice-dollar</v-icon> <span
                class="pl-3">{{ use_language.transfer_notification }}</span>
              <v-spacer />
              <div v-if="detai_statusId == 10 || detai_statusId == 20 || detai_statusId == 30">
                <v-btn class="hidden-xs-only" color="success"
                  @click="dialog_add_slip = true, isFullscreen = false, can_edit_cod()"><v-icon
                    left>fa-plus</v-icon>{{ use_language.add_payment_statement }}</v-btn>
                <v-btn class="hidden-sm-and-up" color="success"
                  @click="dialog_add_slip = true, isFullscreen = true, can_edit_cod()"><v-icon
                    left>fa-plus</v-icon>{{ use_language.add_payment_statement }}</v-btn>
              </div>
            </v-card-title>
            <v-divider />
            <v-row class="form-group">
              <v-col style="background: #fff ;" cols="12" class="pl-10">
                <v-simple-table v-if="detailOrderPayment.length>0" class="packhai-border-table mt-1">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ use_language.slip }}</th>
                        <th class="text-left">{{ use_language.bank }}</th>
                        <th class="text-right">{{ use_language.quantity }}</th>
                        <th class="text-right">{{ use_language.transfer_date }}</th>
                        <th class="text-right">{{ use_language.transfer_notify_date }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in detailOrderPayment" :key="item.name">
                        <td class="text-left">
                          <v-img style="margin:5px;" :src="item.photoLink" aspect-ratio="1" class="grey lighten-2"
                            max-width="50" max-height="50" @click="image_click(item.photoLink, 0)"></v-img>
                        </td>
                        <td class="text-left">{{ item.bankAccountText }}</td>
                        <td class="text-right">{{ format_price(item.amount) }}</td>
                        <td class="text-right">{{ set_format_date_time(item.informDatetime) }}</td>
                        <td class="text-right">{{ set_format_date_time(item.createdDatetime) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card>


          <v-card class="v-card-bottom-30  text-left" elevation="1">
            <v-card-title>
              <v-icon size="20" color="warning darken-3">fa-map-marked-alt</v-icon>
              <span class="pl-3">{{ use_language.receiver_address }}</span>
              <v-spacer />
              <v-btn v-if="(detai_statusId == 10 || detai_statusId == 20 || detai_statusId == 30)" icon
                class="ml-2 hidden-xs-only" @click="bt_edit_address_click('desktop')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn v-if="(detai_statusId == 10 || detai_statusId == 20 || detai_statusId == 30)" icon
                class="ml-2 hidden-sm-and-up" @click="bt_edit_address_click('mobile')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col cols="3" md="4" lg="2"><strong> {{ use_language.receiver_name }} : </strong></v-col>
                <v-col cols="9" md="8" lg="10">{{ this.detai_ShipName }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="3" md="4" lg="2"><strong> {{ use_language.phone_ }} : </strong></v-col>
                <v-col cols="9" md="8" lg="10">{{ this.detai_ShipPhone }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="3" md="4" lg="2"><strong> {{ use_language.address }} : </strong></v-col>
                <v-col cols="9" md="8" lg="10">{{ this.detai_ShippingAddress }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- รูปแบบพัสดุ -->
          <v-card class="v-card-bottom-30  text-left">
            <v-card-title>
              <v-icon size="20" color="deep-orange lighten-1 ">fa-box</v-icon>
              <span class="pl-3">{{ use_language.parcel_format }}</span>
            </v-card-title>
            <v-divider />
            <v-card-text class="ml-7">
              <v-row v-if="this.detail_IsCOD == false">
                <v-col cols="12">
                  <span><v-chip color="info" outlined>{{ use_language.ordinary }}</v-chip></span>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12">
                  <span><v-chip class="mr-5" dark color="red">COD</v-chip> </span>
                </v-col>
                <v-col cols="12">
                  <span><strong>{{ use_language.elite }}</strong> {{ this.detai_CODAmount }} {{ use_language.baht }}</span>
                </v-col>
                <v-col cols="12">
                  <strong> {{ use_language.bank }} : </strong>{{ this.detai_BankName }} {{ this.detai_AccountName }} {{
                    this.detai_AccountNumber }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- สถานะออเดอร์ -->
          <v-card class="v-card-bottom-30 text-left" elevation="1">
            <v-card-title>
              <v-icon size="20" color="orange darken-4 ">fa-box-open</v-icon>
              <span class="pl-3">{{ use_language.order_status_ }}</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row v-for="(item, index) in order_status_history_list" :key="index">
                <v-col cols="5" md="3" class="py-1">
                  {{ item.updateDateTime }}
                </v-col>
                <v-col cols="7" md="9" class="py-1">
                  {{ item.description }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- หมายเหตุ -->
          <v-card class="v-card-bottom-30 text-left">
            <v-card-title>
              <v-icon size="20" color="deep-orange lighten-1 ">fa-sticky-note</v-icon>
              <span class="pl-3">{{ use_language.note }}</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span>{{detail_order.noteForCustomer}}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <div v-if="packageList != null && packageList.length > 0">
            <div v-for="pac in packageList" :key="pac.id">
              <v-card elevation="1" class="v-card-bottom-30 text-left">
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <h3>{{ use_language.box_pack }} #{{ pac.packageNo }}</h3>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.weight }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="pac.weight != null">{{ pac.weight }} {{ use_language.kg }}</span>
                      <span v-else> - </span>
                    </v-col>
                    <v-col cols="4" md="3" lg="2" class="form-group pb-0">
                      <b> {{ use_language.width_length_height }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-0">
                      <span v-if="pac.cubic1 != null && pac.cubic2 != null && pac.cubic3 != null">{{ pac.cubic1 + ' x ' +
                        pac.cubic2 + ' x ' + pac.cubic3 }}</span>
                      <span v-else> - </span>
                      <span v-if="pac.boxName != null && pac.boxName != ''">
                        / {{ use_language.box }} {{ pac.boxName }}
                      </span>
                    </v-col>

                  </v-row>
                  <v-divider>
                  </v-divider>
                  <v-row>
                    <v-col cols="4" md="3" lg="2" class="form-group ">
                      <b> {{ use_language.transport }} : </b>
                    </v-col>
                    <v-col cols="8" md="9" lg="10">
                      <div v-if="pac.trackStatus != null" align="left">
                        <v-img v-if="pac.trackStatus.expressLogo != null" max-height="10vh" max-width="10vh"
                          :src="pac.trackStatus.expressLogo">
                        </v-img>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" md="3" lg="2" class="form-group  ">
                      <b> {{ use_language.tracking_no }} : </b>
                    </v-col>
                       <v-col cols="8" md="9" lg="10">
                        <div>
                          {{ pac.trackStatus.trackingNo }}
                          <div class="pb-2" />
                          <div v-if="pac.trackStatus != null" class="hidden-sm-and-down">
                            <div v-if="pac.trackStatus.status != null && pac.trackStatus.status.length > 0">
                              <div v-for="(item, index) in pac.trackStatus.status" :key="index">
                                <span> {{ formatDatetime(item.date) + " " + item.description }} </span>
                              </div>
                            </div>

                          </div>
                        </div>
                      </v-col>
                  </v-row> 
                  <div v-if="pac.trackStatus != null" class="hidden-sm-and-up">
                    <div v-if="pac.trackStatus.status != null && pac.trackStatus.status.length > 0">
                      <v-row class="pb-2" v-for="(item, index) in pac.trackStatus.status" :key="index">
                        <v-col cols="4" class="pb-0">
                          <span> {{ formatDatetime(item.date) }} </span>
                        </v-col>
                        <v-col cols="8" class="pb-0">
                          <span> {{ item.description }}</span>
                        </v-col>
                      </v-row>
                    </div>

                  </div>
                  <v-row class="pb-2">
                    <v-col cols="4" md="3" lg="2" class="form-group "> <b>{{ use_language.parcel_status }} : </b> </v-col>
                    <v-col cols="8" md="9" lg="10" class="pb-2">
                      <div v-if="pac.trackStatus != null && pac.trackStatus.packageStatusName != ''">
                        <span v-if="pac.trackStatus.packageStatusID == 80" style="color: purple;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 90" style="color: orange;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 100" style="color: #ff7ac0;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 110" style="color: #ff7ac0;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 120" style="color:  #ff7ac0;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 130" style="color:  green;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else-if="pac.trackStatus.packageStatusID == 140" style="color:  red;">{{
                          pac.trackStatus.packageStatusName }} </span>
                        <span v-else>{{ pac.trackStatus.packageStatusName }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <v-dialog v-model="dialog_edit_address" :fullscreen="is_dialog_fullscreen" scrollable persistent
            max-width="500px">
            <v-card>
              <v-card-title>
                {{ use_language.receiver_address }}
                <v-spacer />
                <v-btn icon @click="dialog_edit_address = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-row row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-row row>
                      <v-col cols="12" md="12" lg="12">
                        <h4> {{ use_language.name }} :</h4>
                      </v-col>
                      <v-col cols="12" md="10" lg="12">
                        <v-text-field :value="ShipAddressManage.Name" @change="value => ShipAddressManage.Name = value"
                          autocomplete="off" ref="refShipAddressManageName" outlined hide-details dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-row row>
                      <v-col cols="12" md="12" lg="12">
                        <h4>{{ use_language.tel }} :</h4>
                      </v-col>
                      <v-col cols="12" md="10" lg="12">
                        <v-text-field :value="ShipAddressManage.Phone"
                          @change="value => ShipAddressManage.Phone = value" autocomplete="off"
                          ref="refShipAddressManagePhone" maxlength="10" outlined hide-details
                          @keypress="isNumberWNoDot($event)" dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-row row>
                      <v-col cols="12" md="12" lg="12">
                        <h4> {{ use_language.address }} :</h4>
                      </v-col>
                      <v-col cols="12" md="12" lg="12">
                        <v-text-field :value="ShipAddressManage.TextAddress"
                          @change="value => ShipAddressManage.TextAddress = value" autocomplete="off"
                          ref="refShipAddressManageTextAddress" outlined hide-details dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-row row>
                      <v-col cols="12" md="12" lg="12">
                        <h4>{{ use_language.postal_code }} :</h4>
                      </v-col>
                      <v-col cols="12" md="12" lg="12">
                        <v-autocomplete v-model="ShipAddressManage.Address" ref="refShipAddressManageAddress"
                          :placeholder="use_language.all_address" :items="postcode_mapping"
                          :item-text="item => item.Postcode + ' ' + item.Province + ' ' + item.SubDistrict + ' ' + item.District"
                          outlined @change="ShipAddressManage.PostcodeMappingID = ShipAddressManage.Address.Id" required
                          return-object hide-details dense></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-row row>
                      <v-col class="pb-0" cols="12" md="12" align="left">
                        <v-btn dark color="primary" @click="EditDataShippingAddressManageID()" class="mr-1"><v-icon
                            left>mdi-content-save</v-icon> {{ use_language.button_save }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_photo" scrollable persistent max-width="1000px">
            <v-card>
              <v-card-title>
                <v-spacer />
                <v-btn icon color="info" @click="dialog_photo = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-col cols="12" align="center">
                  <img :src="photo_link">
                </v-col>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_add_slip" :fullscreen="isFullscreen" scrollable max-width="55%" min-width="65%"
            persistent>
            <v-card class="my-0">
              <v-card-title class="primary">
                <span style="color:white;">{{ use_language.add_slip }}</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog_add_slip = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="min-height: 450px;">
                <v-row class="pl-10">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pb-0">
                        <h4>{{ use_language.bank }} :</h4>
                      </v-col>
                      <v-col cols="12" sm="9" lg="10" class="pb-0">
                        <v-radio-group v-model="edit_cod_bank" ref="edit_cod_bank_1">
                          <v-radio v-for="n in cod_bank_data" :key="n.ID" :label="`${n.text}`" :value="n.ID"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pb-0">
                        <h4>{{ use_language.attach_slip }} :</h4>
                      </v-col>
                      <v-col cols="12" sm="9" lg="10" class="pb-0">
                        <v-file-input v-model="input_transferFileUpload" ref="input_transferFileUpload" outlined
                          hide-details dense prepend-icon="" prepend-inner-icon="mdi-file-image">
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pb-0">
                        <h4>{{ use_language.transfer_amount }} :</h4>
                      </v-col>
                      <v-col cols="12" sm="9" lg="10" class="pb-0">
                        <v-text-field :value="input_transferAmount" @change="value => input_transferAmount = value"
                          autocomplete="off" ref="input_transferAmount" type="number" outlined hide-details
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pb-0">
                        <h4>{{ use_language.transfer_date }} :</h4>
                      </v-col>
                      <v-col cols="12" sm="9" lg="10" class="pb-0">
                        <v-menu v-model="menu_transfer_date" :close-on-content-click="false"
                          transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field :value="computed_transfer_date"
                              @change="value => computed_transfer_date = value" autocomplete="off"
                              ref="select_transferDate" outlined prepend-icon="" prepend-inner-icon="mdi-calendar"
                              readonly hide-details dense v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="select_transferDate" no-title
                            :allowed-dates="val => val <= new Date().toISOString().substr(0, 10)"
                            @input="menu_transfer_date = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pb-0">
                        <h4>{{ use_language.time }} :</h4>
                      </v-col>
                      <v-col cols="4" md="3" lg="2" xl="1" class="pb-0">
                        <v-select :value="select_transferHour" hide-details dense
                          @change="value => select_transferHour = value" autocomplete="off" ref="select_transferHour"
                          :items="transferHourItems" outlined></v-select>
                      </v-col>
                      <div class="pt-6">:</div>
                      <v-col cols="4" md="3" lg="2" xl="1" class="pb-0">
                        <v-select :value="select_transferMinute" hide-details dense
                          @change="value => select_transferMinute = value" autocomplete="off"
                          ref="select_transferMinute" :items="transferMinuteItems" outlined></v-select>
                      </v-col>
                    </v-row>
                    <v-row class=" mb-2">
                      <v-col cols="12" md="3" lg="2" class="pb-0"></v-col>
                      <v-col cols="12" md="9" lg="10" class="pb-0">
                        <v-btn @click="add_data_list_payment()" color="primary">{{ use_language.add_slip }}</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="0" md="3" lg="2" class="pb-0"></v-col>
                      <v-col cols="12" md="9" lg="10" class="pb-0">

                        <div v-if="data_list_payment.length == 0" align="left">
                          <h3>{{ use_language.nodata_ }}</h3>
                        </div>
                        <div v-else>
                          <v-simple-table class="packhai-border-table packhai-table">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">{{ use_language.bank }}</th>
                                  <th class="text-center">{{ use_language.date_time }}</th>
                                  <th class="text-right">{{ use_language.elite }}</th>
                                  <th class="text-center">{{ use_language.slip }}</th>
                                  <th class="text-center">{{ use_language.delete }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in data_list_payment" :key="item.name">
                                  <td class="text-left">{{ item.bankAccountText }}</td>
                                  <td class="text-center">{{ item.informDatetime }}</td>
                                  <td class="text-right">{{ item.amount }}</td>
                                  <td class="text-center">
                                    <v-img style="margin:5px;" :src="item.photoLink" aspect-ratio="1"
                                      class="grey lighten-2" max-width="50" max-height="50"
                                      @click="image_click(item.photoLink, 0)"></v-img>
                                  </td>
                                  <td class="text-center"><v-btn icon @click="delete_data_list_payment(item.id)"
                                      color="primary"><v-icon color="red">fa-trash-alt</v-icon></v-btn></td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="data_list_payment.length != 0">
                      <v-col cols="0" md="3" lg="2" class="pb-0"></v-col>
                      <v-col cols="12" md="9" lg="10" class="pb-0">
                        <v-btn @click="upload_data_payment()" color="success">{{ use_language.upload }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Loading from '@/website/components/Loading'
import axios from 'axios'
import { format_order_id, format_price, formatDatetime, get_languages } from '@/website/global_function'
import { logistic_Service, shopService_dotnet, orderService_dotnet, generalService_dotnet, logisticService_dotnet } from '@/website/global'
// import { OrderStatusDict } from '@/website/statusDict'
import { header_token } from '@/website/token'
export default {
  components: {
    Loading
  },

  data: () => ({
    // System
    use_language: null,
    page_loading: true,
    loading: false,
    is_dialog_fullscreen: false,
    dialog_photo: false,
    photo_link: null,
    // Data
    order_master_token: null,
    order_master: null,
    product_list: null,

    input_shipping_name: null,
    input_shipping_phone: '',
    input_shipping_address: null,
    postcode_mapping: null,
    select_shipping_postcode_mapping: null,
    // ที่อยู่
    dialog_edit_address: false,
    shipping_address: null,
    packageList: null,
    //  news
    detai_ID: null,
    detailOrderProductPlatform: [],
    detai_totalPrice: 0,
    detai_DeliveryCost: 0,
    detai_OrderDiscount: 0,
    detai_VATType: null,
    detai_VATAmount: 0,
    detail_sum_unintPrice_and_DeliveryCost: 0,
    detail_IsCOD: false,
    detai_statusId: 10,
    detailOrderPayment: [],
    detai_CODAmount: 0,
    detai_BankName: '',
    detai_AccountName: '',
    detai_AccountNumber: '',
    // cod_list_select : null,
    order_status_history_list: [],

    detail_TrackingNo: null,
    detai_ExpressCompanyID: null,
    shipping_status: [],
    statusExpress: null,


    // shipment
    detai_ShipName: null,
    detai_ShipPhone: null,
    detai_ShippingAddress: null,

    detai_TempAddress: null,

    detai_line: null,
    detai_fackbook: null,
    detai_email: null,

    detai_edit_line: null,
    detai_edit_fackbook: null,
    detai_edit_email: null,

    ShipAddressManage: {
      "ID": null,
      "Name": null,
      "Phone": null,
      "TextAddress": null,
      "Address": null,
      "PostcodeMappingID": null,
      "ShopCustomerID": null
    },


    dialog_add_slip: false,
    isFullscreen: false,

    input_transferFileUpload: null,
    input_transferAmount: null,
    menu_transfer_date: false,
    select_transferDate: new Date().toISOString().substr(0, 10),
    select_transferHour: '00',
    select_transferMinute: '00',
    transferHourItems: [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
      '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'
    ],
    transferMinuteItems: [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
      '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
      '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
      '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
    ],

    data_list_payment: [],

    // แก้ไข cod ธนาคาร
    can_edit_data_cod: false,
    edit_cod_amount: null,
    edit_cod_bank: null,
    cod_bank_data: [],
    cod_list_select: null,
  }),

  async created() {
    let urlPop = window.location.href.split('/').pop()
    const params = new URLSearchParams(urlPop);
    await this.get_postcode_mapping()
    // await this.load_data()
    let id = this.$route.query.id;
    this.use_language = await this.get_languages('th');
    if (id.substr(0, 2) == "PA") {
      id = id.substr(2);
    }
    let createToken = this.$route.query.ct;
    let Token = this.$route.query.t;
    let data_order_id = await this.get_orderid_by_token(id, createToken, Token)

    this.order_id_by_token = data_order_id
    if (data_order_id != null) {
      document.title = this.use_language.menu_orders + ' : ' + this.format_order_id(data_order_id) + ' ' + this.use_language.check_po_status
      await this.load_data_new(this.order_id_by_token)

      await this.get_bank_cod()
    } else {
      document.title = "PACKHAI " + this.use_language.purchase_order_not_found
    }


    await this.GetPackageInfo();

    this.page_loading = false
  },

  watch: {
    // rd_group_bank_account() {
    //     if (this.rd_group_bank_account != null) {
    //         this.is_bt_transfer = false
    //     }
    // },
  },

  computed: {

    cod_list() {
      if (this.use_language == null) return []
      return [{ "ID": 0, "text": this.use_language.ordinary }, { "ID": 1, "text": "COD" }]
    },

    computed_transfer_date() {
      if (this.select_transferDate == null) {
        return null
      } else {
        return this.formatDate(this.select_transferDate)
      }
    },
  },

  methods: {
    format_order_id,
    format_price,
    formatDatetime,
    get_languages,
    async get_postcode_mapping() {
      let response = await axios.post(generalService_dotnet + 'General/get-postcodemapping', {}, { headers: header_token })
      if (response.status == 200) { this.postcode_mapping = response.data }
    },

    bt_edit_address_click(site) {
      this.input_shipping_name = this.shipping_address.Name
      this.input_shipping_phone = this.shipping_address.Phone
      this.input_shipping_address = this.shipping_address.Address
      this.select_shipping_postcode_mapping = {
        'id': this.shipping_address.PostcodeMappingID,
        'district': this.shipping_address.Tumbon,
        'amphoe': this.shipping_address.Amphoe,
        'province': this.shipping_address.Province,
        'zipcode': this.shipping_address.Postcode,
      }
      if (site == 'desktop') {
        this.is_dialog_fullscreen = false
      } else {
        this.is_dialog_fullscreen = true
      }
      this.dialog_edit_address = true
    },


    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },

    async load_data_new(order_id_by_token) {
      await axios.all([
        axios.post(orderService_dotnet + 'Order/get-order-item', { 'orderID': order_id_by_token }, { headers: header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-item-temp', { 'orderID': order_id_by_token }, { headers: header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-payment', { 'orderID': order_id_by_token }, { headers: header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-master', { 'orderID': order_id_by_token }, { headers: header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-item-invoice', { 'orderID': order_id_by_token }, { headers: header_token }),
        axios.post(orderService_dotnet + 'Order/get-order-satus-history', { 'orderID': order_id_by_token }, { headers: header_token }), // order_status_history_list
      ]).then(axios.spread((res_OrderItemList, res_OrderItemTempList, res_OrderPaymentList, res_OrderMasterDict, res_OrderItemInvoiceList, res_StatusHistory) => {
        var detail_order = res_OrderMasterDict.data
        this.detail_order = res_OrderMasterDict.data

        this.detai_ID = detail_order['id']
        this.detai_statusId = detail_order['shippingStatusID']
        this.detai_totalPrice = parseFloat(detail_order['totalPrice'] == null ? 0 : detail_order['totalPrice'])
        this.detai_DeliveryCost = parseFloat(detail_order['deliveryCost'] == null ? 0 : detail_order['deliveryCost'])
        this.vat_percent = detail_order['vatPercent']
        this.textField_deliveryCost = parseFloat(detail_order['deliveryCost'] == null ? 0 : detail_order['deliveryCost'])
        this.select_vatType = detail_order['vatType']
        this.detai_VATType = this.select_vatType

        this.detai_ShipName = detail_order['receiverName']
        this.detai_ShipPhone = detail_order['receiverPhone']

        this.detai_OrderDiscount = parseFloat(detail_order['orderDiscount'] == null ? 0 : detail_order['orderDiscount'])
        this.detai_VATAmount = parseFloat(detail_order['vatAmount'] == null ? 0 : detail_order['vatAmount'])
        this.detail_IsCOD = detail_order['isCOD']
        this.detai_CODAmount = detail_order['codAmount']
        this.detail_TrackingNo = detail_order['trackingNo']
        this.detai_ExpressCompanyID = detail_order['expressCompanyID']

        var check_data = false
        if (res_OrderItemInvoiceList.data.length > 0) {
          // order set
          this.detailOrderProduct = res_OrderItemInvoiceList.data
          this.product_list = res_OrderItemInvoiceList.data
          check_data = true
        } else {
          // order item ปกติ
          this.detailOrderProduct = res_OrderItemList.data
          this.product_list = res_OrderItemList.data
        }

        for (var i3 = 0; i3 < this.detailOrderProduct.length; i3++) {
          this.detailOrderProduct[i3]['productMasterId'] = this.detailOrderProduct[i3]['productMasterID']
          if (check_data) {
            this.detailOrderProduct[i3]['productMasterItemId'] = this.detailOrderProduct[i3]['productMasterItemID']
          }
        }
        this.detailOrderProduct_tmp = [...this.detailOrderProduct]
        this.detailOrderProduct_pack = res_OrderItemList.data
        this.detail_sum_unintPrice = 0
        this.detail_sum_unintPrice_and_DeliveryCost = 0
        for (var i = 0; i < this.detailOrderProduct.length; i++) {
          var item_quantity = this.detailOrderProduct[i]['quantity'] == null ? 0 : this.detailOrderProduct[i]['quantity']
          var item_unitPrice = this.detailOrderProduct[i]['unitPrice'] == null ? 0 : this.detailOrderProduct[i]['unitPrice']
          this.detail_sum_unintPrice += parseFloat(item_quantity) * parseFloat(item_unitPrice)
        }
        this.detail_sum_unintPrice_and_DeliveryCost = parseFloat(this.detail_sum_unintPrice) + parseFloat(this.detai_DeliveryCost)

        //  orderPayment
        this.detailOrderPayment = res_OrderPaymentList.data
        if(this.detailOrderPayment==null||this.detailOrderPayment==''){
          this.detailOrderPayment=[];
        }
        // order status history
        this.order_status_history_list = res_StatusHistory.data

        // shipAddress
        if (detail_order['shippingAddressID'] != null) {
          this.detai_ShippingAddressID = detail_order['shippingAddressID']
          this.getDataShippingAddressManageID(detail_order['shippingAddressID'])
        }

        // getshippingAddress
        if (detail_order.shippingAddressID) {
          this.get_shippingAddress_loadpage(detail_order.shippingAddressID)
        }

        if (detail_order.shopBankAccountID != null) {
          this.get_order_shop_bank_by_id(detail_order.shopBankAccountID)
        } else {
          this.detai_BankName = null
          this.detai_AccountNumber = null
          this.detai_AccountName = null
        }



      }));


    },

    async GetPackageInfo() {
      await axios.all([
        axios.post(orderService_dotnet + 'Package/get-order-package-info', { 'orderID': this.detai_ID }, { headers: header_token }),
        axios.get(logistic_Service + 'Logistic/get-track-status?OrderMasterID=' + this.detai_ID, { headers: header_token }),
      ]).then(axios.spread((res_PackageList, res_TrackStatus) => {
        this.packageList = res_PackageList.data.packageList;

        this.packageList.forEach(element => {

          var trackStatusTemp = res_TrackStatus.data.packages.filter(packageno => packageno.packageNo == element.packageNo);
          if (trackStatusTemp.length > 0) {
            element.trackStatus = trackStatusTemp[0];
          }
        });
        this.packageList.sort((a, b) => a.packageNo - b.packageNo);
         

      }));



    },

    async get_orderid_by_token(id, ctoken, token) {
      let response = await axios.post(orderService_dotnet + 'Order/get-orderid-by-token', { "orderID": id, "createToken": ctoken, 'token': token }, { headers: header_token })
      this.order_token = response.data.id
      return this.order_token

    },

    async upload_data_payment() {
      if (this.data_list_payment.length > 0) {
        this.loading = true
        let response = await axios.post(orderService_dotnet + 'Order/detail-order-add-order-payment', {
          "orderPaymentList": this.data_list_payment
        },
          { headers: header_token })
        if (response.data.status) {
          this.data_list_payment = []
          this.can_edit_data_cod = false
          this.dialog_add_slip = false

          this.load_data_new(this.detai_ID)
        }
        this.loading = false
      }
    },

    set_format_date_time(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0] + ' ' + time_tmp
        return set_dattime
      } else {
        return ""
      }
    },

    async add_data_list_payment() {
      if (this.edit_cod_bank == null) {
        alert(this.use_language.please_select_bank)
        return
      } else if (this.input_transferFileUpload == null) {
        this.$refs.input_transferFileUpload.focus()
        return
      } else if (this.input_transferAmount == null) {
        this.$refs.input_transferAmount.focus()
        return
      } else if (this.select_transferDate == null) {
        this.$refs.select_transferDate.focus()
        return
      } else if (this.select_transferHour == null) {
        this.$refs.select_transferHour.focus()
        return
      } else if (this.select_transferMinute == null) {
        this.$refs.select_transferMinute.focus()
        return
      }

      var fileToBase64 = null
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })

      if (this.input_transferFileUpload != null) {
        fileToBase64 = await toBase64(this.input_transferFileUpload)
      } else {
        fileToBase64 = null
      }

      var informDatetime_tmp = new Date(this.select_transferDate + ' ' + this.select_transferHour + ':' + this.select_transferMinute + ':' + '00')
      const _date = new Date(informDatetime_tmp)
      informDatetime_tmp = new Date(_date.getTime() + 7 * (60 * 60 * 1000)).toISOString()

      // var data_list_payment = []
      var payment_list = {
        "id": this.data_list_payment.length + 1,
        "orderMasterId": this.detai_ID,
        "bankAccountText": this.bank_id_to_text(this.edit_cod_bank),
        "amount": parseFloat(Number(this.input_transferAmount).toFixed(2)),
        "photoLink": fileToBase64,
        "informDatetime": informDatetime_tmp,
        "createdDatetime": new Date(Date.now() + 7 * (60 * 60 * 1000)).toISOString(),
        "approved": null,
        "approvedBy": null,
        "disApproved": null,
        "disApprovedBy": null,
        "updateDateTime": null,
      }

      this.data_list_payment.push(payment_list)

      // เคลียข้อมูล
      this.edit_cod_bank = null
      this.input_transferFileUpload = null
      this.input_transferAmount = null
      this.select_transferDate = null
      this.select_transferHour = null
      this.select_transferMinute = null
    },

    bank_id_to_text(id) {
      for (var e = 0; e < this.cod_bank_data.length; e++) {
        if (this.cod_bank_data[e]['ID'] == id) {
          return this.cod_bank_data[e]['text']
        }
      }
    },

    async get_bank_cod() {

      this.loading = true
      let res2 = await axios.post(shopService_dotnet + 'Shop/get-shop-bank-list', { "shopID": this.detail_order.shopID },
        { headers: header_token })
      var bank_list_tmp = []
      if (res2.data != null && res2.data.length != 0) {
        for (var i = 0; i < res2.data.length; i++) {
          var back_dict = {
            "ID": res2.data[i]['id'],
            "text": res2.data[i]['fullBankName']
          }
          bank_list_tmp.push(back_dict)
        }
      } else {
        this.cod_bank_data = []
      }

      this.cod_bank_data = bank_list_tmp
      this.loading = false

    },

    can_edit_cod() {
      if (this.detail_IsCOD == true) {
        this.cod_list_select = 1
      } else {
        this.cod_list_select = 0
      }
    },

    img_express_return(express_id) {
      if (express_id != null) {
        if (express_id == 1) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/BESTSmallLogo.JPG'
        }
        else if (express_id == 2) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/kerry_ExpressLogo.png'
        }
        else if (express_id == 3) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/EMSSmallLogo.JPG'
        }
        else if (express_id == 4) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/thaipost.jpg'
        }
        else if (express_id == 5) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/thaipost.jpg'
        }
        else if (express_id == 6) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/NimSmallLogo.JPG'
        }
        else if (express_id == 7) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/FlashSmallLogo.JPG'
        }
        else if (express_id == 8) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/shopee.png'
        }
        else if (express_id == 9) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png'
        }
        else if (express_id == 10) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/SCGSmallLogo.JPG'
        }
        else if (express_id == 11) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/JandTSmallLogo.png'
        }
        else if (express_id == 12) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/ninjavan_logo.png'
        }
        else if (express_id == 13) {
          return 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/dhl.PNG'
        }
      } else {
        return null
      }
    },

    async get_order_shop_bank_by_id(val) {
      // getshippingAddress
      let res = await axios.post(orderService_dotnet + 'Order/get-order-shop-bank-by_id', { "shopBankID": val },
        { headers: header_token })
      this.detai_BankName = res.data[0].bankNameTH
      this.detai_AccountNumber = res.data[0].accountNumber
      this.detai_AccountName = res.data[0].accountName
    },

    async get_shippingAddress_loadpage(val) {
      // getshippingAddress
      let res2 = await axios.post(shopService_dotnet + 'Shop/get-shipping-address-list', { "id": val, "isAscending": true },
        { headers: header_token })
      this.detai_line = res2.data[0].customerLine
      this.detai_fackbook = res2.data[0].customerFacebook
      this.detai_email = res2.data[0].customerEmail

      this.detai_edit_line = res2.data[0].customerLine
      this.detai_edit_fackbook = res2.data[0].customerFacebook
      this.detai_edit_email = res2.data[0].customerEmail

      this.detai_ShippingAddress = res2.data[0].address + ' ' + res2.data[0].subDistrict + ' ' + res2.data[0].district + ' ' + res2.data[0].province + ' ' + res2.data[0].postcode

      if (this.detai_TempAddress == null) {
        this.detai_TempAddress = res2.data[0].name + ' ' + res2.data[0].phone + ' ' + this.detai_ShippingAddress
      }
    },

    async getDataShippingAddressManageID(addressID) {
      this.loading = true

      let res2 = await axios.post(shopService_dotnet + 'Shop/get-shipping-address-list', { "id": addressID, "isAscending": true },
        { headers: header_token })
      if (res2.data.length > 0) {
        var ShipAddressManage = res2.data[0]
        this.ShipAddressManage.ID = ShipAddressManage.id
        this.ShipAddressManage.Name = ShipAddressManage.name
        this.ShipAddressManage.Phone = ShipAddressManage.phone
        this.ShipAddressManage.TextAddress = ShipAddressManage.address
        this.ShipAddressManage.ShopCustomerID = ShipAddressManage.shopCustomerID

        if (ShipAddressManage['postcodeMappingId'] != null) {
          for (var i = 0; i < this.postcode_mapping.length; i++) {
            if (this.postcode_mapping[i]['Id'] == ShipAddressManage['postcodeMappingId']) {
              this.ShipAddressManage.PostcodeMappingID = ShipAddressManage['postcodeMappingId']
              this.ShipAddressManage.Address = {
                "Id": this.postcode_mapping[i]['Id'],
                "SubDistrict": this.postcode_mapping[i]['SubDistrict'],
                "District": this.postcode_mapping[i]['District'],
                "Province": this.postcode_mapping[i]['Province'],
                "Postcode": this.postcode_mapping[i]['Postcode']
              }
              break;
            }
          }
        } else {
          this.ShipAddressManage.Address = {
            "Id": ShipAddressManage['postcodeMappingId'],
            "SubDistrict": ShipAddressManage['subDistrict'],
            "District": ShipAddressManage['district'],
            "Province": ShipAddressManage['province'],
            "Postcode": ShipAddressManage['postcode']
          }
        }
      }

      this.loading = false
    },
    async EditDataShippingAddressManageID() {
      if (this.ShipAddressManage.ID != null) {
        this.loading = true
        await axios.all([
          axios.post(shopService_dotnet + 'Customer/update-customer-address', {
            "id": this.ShipAddressManage.ID,
            "shopCustomerID": this.ShipAddressManage.ShopCustomerID,
            "name": this.ShipAddressManage.Name,
            "phone": this.ShipAddressManage.Phone,
            "address": this.ShipAddressManage.TextAddress,
            "postcodeMappingID": this.ShipAddressManage.PostcodeMappingID,
            "isDefault": true
          }, { headers: header_token }),
          axios.post(shopService_dotnet + 'Customer/update-customer-info', {
            "id": this.ShipAddressManage.ShopCustomerID,
            "name": this.ShipAddressManage.Name,
            "phone": this.ShipAddressManage.Phone,
            "line": this.detai_edit_line,
            "facebook": this.detai_edit_fackbook,
            "email": this.detai_edit_email
          }, { headers: header_token })
        ]).then(axios.spread((res1, res2) => {
          // console.log(res1);
          // console.log(res2);
          this.dialog_edit_address = false
          this.load_data_new(this.order_id_by_token)
        }));
        this.loading = false
      }

    },

    photo_click(url) {
      this.photo_link = url
      this.dialog_photo = true
    },

    copyTrackingCode() {
      if (this.detai_ExpressCompanyID == 2) {
        window.open('https://th.kerryexpress.com/en/track/?track=' + this.detail_TrackingNo)
      } else if (this.detai_ExpressCompanyID == 3) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detai_ExpressCompanyID == 4) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detai_ExpressCompanyID == 5) {
        window.open('https://track.thailandpost.co.th/')
      } else if (this.detai_ExpressCompanyID == 6) {
        window.open('https://www.nimexpress.com/web/p/tracking')
      } else if (this.detai_ExpressCompanyID == 10) {
        window.open('https://www.scgexpress.co.th/tracking')
      } else if (this.detai_ExpressCompanyID == 11) {
        window.open('https://www.jtexpress.co.th/index/query/gzquery.html')
      } else if (this.detai_ExpressCompanyID == 12) {
        window.open('https://www.ninjavan.co/th-th/tracking')
      } else if (this.detai_ExpressCompanyID == 13) {
        window.open('https://www.dhl.com/th-th/home/tracking.html')
      }
    },
  }
}
</script>

<style scoped>
/* >>>.v-dialog {
      -webkit-box-shadow: none;
      box-shadow: none;
  } */

>>>.bex48-logo {
  width: 12.533vw;
  height: 11.2vw;
  display: block;
  /* margin: 8.8vw auto 1.6vw; */
  margin: 1.6vw auto 1.6vw;
}

.packhai-border-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.packhai-border-table thead {
  color: white;
}

.packhai-border-table thead tr th {

  font-weight: bold;
  font-size: 1rem;
}

@media (max-width:600px) {
  .v-data-table td {
    font-size: 9px;
    padding-left: 0px;
  }

  .v-data-table th {
    font-size: 9px;
    padding-left: 0px;
  }

  .v-card__title {
    font-size: 0.9rem;
  }

  .v-card__subtitle,
  .v-card__text {
    font-size: 0.7rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.0071428571em;
  }

  .v-input {
    font-size: 10px !important;
  }

  .v-label {
    font-size: 10px !important;
  }
}
</style>
